/**
 * RFC6749 で定義 https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2
 */
export function hasAuthSuccessParams(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): boolean {
  if (searchParams.has('error')) {
    return false;
  }
  return searchParams.has('code') && searchParams.has('state');
}

/**
 * RFC6749 で定義 https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2.1
 */
export function hasAuthErrorParams(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): boolean {
  return searchParams.has('error');
}

export function getErrorDescriptionParam(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): string | undefined {
  // auth0 actions で deny 時に定義する
  return searchParams.get('error_description') ?? undefined;
}
